import { Box, Typography } from "@mui/material";
import React from "react";

const StepHeader = ({ title, description }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "4px",
      }}
    >
      <Typography
        fontSize={18}
        fontWeight={600}
        lineHeight="28px"
        color="#101828"
      >
        {title}
      </Typography>
      <Typography color="#475467">{description}</Typography>
    </Box>
  );
};

export default StepHeader;
